import { ThirdPartyCost } from '@app/core/model/third-party-cost.model'
import { Type } from 'class-transformer'
import { User } from '@app/core/model/user.model'

export class LibrarySection {
  @Type(() => User) createdBy: User
  @Type(() => User) updatedBy: User
  createdTs: string
  updatedTs: string
  id: number
  name: string
  order: number
  @Type(() => ThirdPartyCost) thirdPartyCosts: ThirdPartyCost[]
}
